// Sous-onglets des pages (voir AppShell `subnav`). `perm` : permission
// nécessaire pour voir le sous-onglet (lib/permissions).
export const carteSubnav = () => [
  { to: "/carte", label: "Carte", end: true, id: "carte" },
  { to: "/carte/tournees", label: "Tournées & zones", id: "tournees", perm: "carte_tournees_voir" },
];

export const scansSubnav = () => [
  { to: "/scans", label: "Remise de scan", end: true, id: "remise", perm: "scan_remise" },
  { to: "/scans/reception", label: "Scans à réceptionner", id: "reception", perm: "scan_reception" },
  { to: "/scans/config", label: "Config scan", id: "config", perm: "scan_config" },
];

export const adminSubnav = () => [
  { to: "/admin", label: "Utilisateurs", end: true, id: "utilisateurs" },
];

export const colisSubnav = () => [
  { to: "/colis", label: "Colis", end: true, id: "colis", perm: "colis_colis" },
  { to: "/colis/depot", label: "Dépôt restant", id: "depot", perm: "colis_depot" },
  { to: "/colis/cage", label: "Colis cage", id: "cage", perm: "colis_cage" },
  { to: "/colis/listes", label: "Listes de colis", id: "listes", perm: "colis_listes" },
];
